import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataTooltipBorderWidthValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'number',
            empty: false,
            mandatory: false
        };
    }
}
